import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ConfirmedValidator } from './ConfirmedValidator';
import { MatDialog,MatDialogRef } from '@angular/material/dialog';
import { TermsconditionsComponent } from './termsconditions/termsconditions.component';
import { ValidationService } from 'src/app/services/validation.service';
import { RegistersuccessComponent } from './registersuccess/registersuccess.component';
import { countries } from 'country-list-json';
import * as isoCountries from 'i18n-iso-countries';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ThemeService } from 'src/app/services/theme.service';
import { ApiService } from 'src/app/services/api.service';
import { QuotationPopupComponent } from './quotation-popup/quotation-popup.component';
import { UtilsService } from 'src/app/services/utils.service';
import { AuthService } from 'src/app/services/auth.service';
import {  TemplateRef } from '@angular/core';
import { AgreeComponent } from '../shared';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { Observable, of, timer } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, map, switchMap, take } from 'rxjs/operators';

interface country {
  value: any;
  viewValue: string;
}

interface PricingSensorItem {
  label: string;
  category: 'MSI' | 'SAR' | 'HSI' | 'SWIR' | 'GHG' | 'TIR' | 'neutral';
}

interface PricingPlanCard {
  planId: number;
  title: string;
  subtitle: string;
  depositLabel: string;
  depositAmount: string;
  depositSupport: string;
  sensorHeading: string;
  sensorSubtext: string;
  sensorCount: string;
  sensorItems: PricingSensorItem[];
  featureHeading: string;
  features: string[];
  recommended?: boolean;
  enterprise?: boolean;
  enterpriseSensorSummary?: string;
  tooltipPlanId?: number;
}
@Component({
  selector: 'app-userregister',
  templateUrl: './userregister.component.html',
  styleUrls: ['./userregister.component.scss']
})
export class UserregisterComponent implements OnInit {
  confirmshowPassword: boolean = true
  showPassword: boolean = true;
  registerForm: any = FormGroup;
  signupform: any = FormGroup;
  submitted = false;
  notRegistered:any;
  warnMsg: any;
  imgUrl = '';
  userPhotoFile: any;
  imageType = false;
  oversize = false;
  validationMessages: any;
  uploaded: boolean = false;
  upload: boolean = false;
  check: boolean = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  successMsg: boolean = false;
  dialog: any;
  countries: any;
  isInIframe: boolean;
  organisationTypes: any;
  quotation: boolean = false;
  quotationAmount: number = 0;
  subscription: boolean = false;
  selectedOption: string = 'withDeposit';
  tooltipImagePath: string;
  register: boolean = false;
  registerBlockedMsg: string = '';
  currentStep: number = 1;
  totalSteps: number = 3;
  stepErrorMsg: string = '';
  draftSavedState: 'idle' | 'saving' | 'saved' | 'error' = 'idle';
  @ViewChild('draftSavedDialogTpl') draftSavedDialogTpl!: TemplateRef<any>;
  draftSavedDialogRef!: MatDialogRef<any>;
  draftRestoreMsg: string = '';
  draftExistsMsg: string = '';
  private restoringFromDraft = false;
  filteredCountries: any[] = [];
  countryFilterCtrl = new FormControl('');
  selectedPlan: string | null = null;
  expandedPricingPlanIds: number[] = [];
  plans = [
  {
    planId:1,
    accessDetails:[
      {heading:"Access up to five Imaging Sensors"},
      "1 sub-m Multispectral Imaging (MSI)",
      "1 above 1m MSI",
      "1 sub-10m Hyperspectral Imaging (HSI)",
      "2 sub-m Synthetic Aperture Radar (SAR) (X band)"
    ]
  },
  {
    planId:2,
    accessDetails:[
      {heading:"Access up to ten Imaging Sensors"},
      "1 Panchromatic (PAN)",
      "4 MSI (below 1m and above 1m)",
      "3 SAR (X, C bands)",
      "1 HSI",
      "1 Thermal Infrared (TIR)"
    ]
  },
  {
    planId:3,
    accessDetails:[
      {heading:"Full access to all Sensors"},
      "Over 20 imaging and non-imaging sensors, including more MSI, SAR and HSI",
      "MSI starts at 15cm",
      "Stereo and Tri-stereo in several optical resolutions",
      "L-band SAR",
      "InSAR (X, C, and L bands)",
      "Greenhouse Gases (GHG)",
      "Automatic Identification System (AIS) and RF-communication"
    ]
  }
];
  pricingCards: PricingPlanCard[] = [
    {
      planId: 1,
      title: 'Starter',
      subtitle: 'For First-Time Or Occasional Users',
      depositLabel: 'Annual Deposit',
      depositAmount: 'No Minimum',
      depositSupport: 'Pay Now via PayPal or Stripe',
      sensorHeading: 'Imaging sensors',
      sensorSubtext: 'Click to view breakdown',
      sensorCount: '5',
      tooltipPlanId: 1,
      featureHeading: 'Includes',
      sensorItems: [
        { label: '1 sub-m Multispectral Imaging (MSI)', category: 'MSI' },
        { label: '1 above 1m MSI', category: 'MSI' },
        { label: '1 sub-10m Hyperspectral Imaging (HSI)', category: 'HSI' },
        { label: '2 sub-m Synthetic Aperture Radar (SAR) (X band)', category: 'SAR' }
      ],
      features: [
        'Single user, one tasking workflow',
        'Support via platform ‘contact us’',
      ]
    },
    {
      planId: 2,
      title: 'Standard',
      subtitle: 'For Regular Users',
      depositLabel: 'Annual Deposit From',
      depositAmount: 'USD 5,000',
      depositSupport: 'Pay Now, Debit Account',
      sensorHeading: 'Imaging sensors',
      sensorSubtext: 'Click to view breakdown',
      sensorCount: '10',
      tooltipPlanId: 2,
      featureHeading: 'More of everything from users to sensors',
      sensorItems: [
        { label: '1 Panchromatic (PAN)', category: 'MSI' },
        { label: '4 MSI (below 1m and above 1m)', category: 'MSI' },
        { label: '3 SAR (X, C bands)', category: 'SAR' },
        { label: '1 HSI', category: 'HSI' },
        { label: '1 Thermal Infrared (TIR)', category: 'TIR' }
      ],
      features: [
        'Multi-user, multi-tasking workflows',
        'Access to simple feeds',
        'Support via onboarding, platform ‘contact us’ and email'
      ]
    },
    {
      planId: 3,
      title: 'Premium',
      subtitle: 'For High-Volume Users',
      depositLabel: 'Annual Deposit From',
      depositAmount: 'USD 50,000',
      depositSupport: 'Pay Now, Debit Account, or Pay Later by invoice',
      sensorHeading: 'Sensors',
      sensorSubtext: 'Full constellation access',
      sensorCount: '20+',
      tooltipPlanId: 3,
      recommended: true,
      featureHeading: 'Everything in Standard plus',
      sensorItems: [
        { label: 'Over 20 imaging and non-imaging sensors, including more MSI, SAR and HSI', category: 'neutral' },
        { label: 'MSI starts at 15cm', category: 'MSI' },
        { label: 'Stereo and Tri-stereo in several optical resolutions', category: 'MSI' },
        { label: 'L-band SAR', category: 'SAR' },
        { label: 'InSAR (X, C, and L bands)', category: 'SAR' },
        { label: 'Greenhouse Gases (GHG)', category: 'GHG' },
        { label: 'Shortwave Infrared (SWIR)', category: 'SWIR' },
        { label: 'Automatic Identification System (AIS) and RF-communication', category: 'neutral' }
      ],
      features: [
        'Tip-and-Cue and other advanced tasking, permission-based enterprise workflows and user level budgets',
        'Access to advanced feeds',
        'Support via onboarding, platform ‘contact us’, email and monthly check-in',
      ]
    },
    {
      planId: 4,
      title: 'Enterprise',
      subtitle: 'For Related Entities & Organisations',
      depositLabel: 'Annual Deposit From',
      depositAmount: 'USD 100,000',
      depositSupport: 'Pay Now, Debit Account, or Pay Later by invoice',
      sensorHeading: 'Sensors',
      sensorSubtext: 'Full constellation access',
      sensorCount: '20+',
      enterprise: true,
      enterpriseSensorSummary: 'Full Premium sensor suite, tailored to operational requirements.',
      featureHeading: 'Everything in Premium plus',
      sensorItems: [
        { label: 'All Premium sensor access', category: 'neutral' },
        { label: 'Expanded MSI, SAR, HSI and advanced analytics coverage', category: 'MSI' },
        { label: 'Enterprise-scale access for related entities', category: 'neutral' }
      ],
      features: [
        'Hierarchical and multi-account management',
        'Data and information report generation',
        'Activity tracking',
        'Slack + dedicated support channel',
        'Support via onboarding, platform ‘contact us’, email, Slack and monthly check-in'
      ]
    }
  ];

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private matdialog: MatDialog,
    private vs: ValidationService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private themeService: ThemeService,
    private apiService: ApiService,
    public utilsService: UtilsService,
    private authService: AuthService,
     private dialogRef: MatDialog
    ) {
      this.isInIframe = this.themeService.isInIframe();
      this.tooltipImagePath = '../../../assets/images/union.svg';
     }


  saveDraft(): void {
    if (this.draftSavedState === 'saving') return;
    const emailCtrl = this.registerForm?.get('email');
    if (!emailCtrl?.valid) return;
    this.draftSavedState = 'saving';
    const step1Data = { ...this.registerForm.value };
    const step2Data = { ...this.signupform.value };
    delete step2Data['password'];
    delete step2Data['confirm_password'];
    this.recaptchaV3Service.execute('saveDraft').subscribe({
      next: (token: string) => {
        const payload = {
          email: emailCtrl.value,
          formData: { ...step1Data, ...step2Data, selectedPlan: this.selectedPlan },
          currentStep: this.currentStep,
          reCAPTCHAToken: token,
        };
        this.userService.saveDraft(payload).subscribe({
          next: () => {
            this.draftSavedState = 'saved';
            this.draftSavedDialogRef = this.matdialog.open(this.draftSavedDialogTpl, {
              width: '380px',
              disableClose: false,
            });
            this.draftSavedDialogRef.afterClosed().subscribe(() => {
              this.draftSavedState = 'idle';
            });
          },
          error: () => {
            this.draftSavedState = 'error';
            setTimeout(() => { this.draftSavedState = 'idle'; }, 2500);
          },
        });
      },
      error: () => {
        this.draftSavedState = 'error';
        setTimeout(() => { this.draftSavedState = 'idle'; }, 2500);
      },
    });
  }

  ngOnInit(): void {
    this.selectedPlan = this.authService.getCookie('plan');
    if (this.selectedPlan) {
      this.notRegistered = false
    }
    this.countries = countries;
    this.filteredCountries = [...countries];
    this.countryFilterCtrl.valueChanges.subscribe(search => {
      const s = (search || '').toLowerCase();
      this.filteredCountries = s
        ? this.countries.filter((c: any) => c.name.toLowerCase().includes(s))
        : [...this.countries];
      // If search is active and the currently selected country is filtered out, clear it
      if (s) {
        const currentCountry = this.signupform?.get('country')?.value;
        if (currentCountry) {
          const stillVisible = this.filteredCountries.some(
            (c: any) => this.compareCountry(c, currentCountry)
          );
          if (!stillVisible) {
            this.signupform.get('country')?.setValue(null);
            this.signupform.get('country')?.markAsTouched();
          }
        }
      }
    });
    this.apiService.getOrganisations().subscribe((res: any) => {
      const types: any[] = res?.organisationtypes || [];
      this.organisationTypes = types.slice().sort((a: any, b: any) => {
        if (a.key === 'other') return 1;
        if (b.key === 'other') return -1;
        return a.name.localeCompare(b.name);
      });
    });
    this.registerForm = this.formBuilder.group({
      fullName: ['',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
          this.vs.userNameValidator,
        ],
      ],
      lastName: ['',
      [
        Validators.required,
        Validators.maxLength(50),
        this.vs.userNameValidator,
      ],
     ],
      displayName: ['',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(15),
          this.vs.userNameValidator,
        ],
      ],
      email: ['', [Validators.required, this.vs.trimmedEmailPatternValidator()], [this.emailNotTakenValidator()]],
    });
    this.signupform = this.formBuilder.group({
      companyName: [
        '',
        [
          Validators.required
        ],
      ],
      organisationType: [
        '',
        [
          Validators.required
        ],
      ],
      organisationTypeOther: ['', [Validators.maxLength(15)]],
      phonenumber: ['', [Validators.required]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern('^(?=.*[A-Z])(?=.*[!@#$%^&_+=]).*$'),
      ]],
      confirm_password: ['', [Validators.required]],
      address1: ['', [Validators.required]],
      address2: [''],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      zip_code: ['', [Validators.required]],
      role: [
        '',
        [
          Validators.required
        ],
      ],
      department: [
        '',
        [
          Validators.required
        ],
      ],
      website: ['', [
        Validators.required,
        Validators.pattern(
          /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/ // URL regex
        )],
      ],
    }, {
      validator: ConfirmedValidator('password', 'confirm_password')
    });
    this.validationMessages = this.vs.account_validation_messages;

    // Notify user when they type an email that has an existing saved draft
    this.registerForm.get('email')!.valueChanges.pipe(
      debounceTime(600),
      distinctUntilChanged((a: string, b: string) => a.trim() === b.trim()),
      filter((val: string) => {
        const ctrl = this.registerForm.get('email')!;
        return (ctrl.valid || ctrl.status === 'PENDING') && !!val.trim() && !this.restoringFromDraft;
      }),
    ).subscribe((email: string) => {
      const trimmedEmail = email.trim();
      this.draftExistsMsg = '';
      // Check if email has a saved draft
      this.userService.checkDraft(trimmedEmail).subscribe({
        next: (res: any) => {
          if (res?.hasDraft) {
            this.draftExistsMsg =
              'You have a saved draft for this email. Check your inbox for the resume link to pick up where you left off.';
          }
        },
        error: () => { /* silently ignore */ },
      });
    });

    // Restore saved draft if a draftToken is present in the URL
    const draftToken = this.route.snapshot.queryParamMap.get('draftToken');
    if (draftToken) {
      this.userService.getDraft(draftToken).subscribe({
        next: (res: any) => {
          this.restoringFromDraft = true;
          if (res?.formData) {
            this.registerForm.patchValue(res.formData);
            this.signupform.patchValue(res.formData);
            // Re-hydrate plan if cookie has expired (e.g. resumed from email link after 30 min)
            if (!this.selectedPlan && res.formData.selectedPlan) {
              this.selectedPlan = res.formData.selectedPlan;
              this.notRegistered = false;
              this.authService.setCookie('plan', res.formData.selectedPlan, 30);
              this.authService.emitPlan(res.formData.selectedPlan);
            }
          }
          // Restore the step the user was on when they saved
          // if (res?.currentStep) {
          //   this.currentStep = res.currentStep;
          // }
          // Wait longer than the debounce window (600ms) before re-enabling the check
          setTimeout(() => { this.restoringFromDraft = false; }, 800);
          this.draftRestoreMsg = 'Your saved registration draft has been loaded. Please review your details and continue.';
        },
        error: () => {
          this.draftRestoreMsg = 'The resume link has expired or is invalid. Please start a new registration.';
        },
      });
    }
    this.subscribeStepValidation();
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    this.onResetClick(event);
  }

  Space(event: any) {
    if (event.target.selectionStart === 0 && event.code === "Space") {
      event.preventDefault();
    }
  }

  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  public toggleconfirmPasswordVisibility(): void {
    this.confirmshowPassword = !this.confirmshowPassword;
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;

  }
  get sign() {
    return this.signupform.controls;

  }
  keyPress(event: any) {
    // reserved for future email-field keypress handling
  }

  goToStep2(): void {
    if (this.registerForm.status === 'PENDING') {
      this.registerForm.statusChanges.pipe(
        filter((s: string) => s !== 'PENDING'),
        take(1)
      ).subscribe(() => this.goToStep2());
      return;
    }
    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      this.stepErrorMsg = 'Please complete all identified mandatory fields.';
      return;
    }
    this.stepErrorMsg = '';
    this.submitted = true;
    this.currentStep = 2;
  }

  goToStep3(): void {
    // Sync conditional validators based on current organisationType value,
    // because onOrgTypeChange only fires on manual selection (not draft restore / back-navigation).
    const orgTypeOtherCtrl = this.signupform.get('organisationTypeOther');
    const isOtherSelected = this.signupform.get('organisationType')?.value?.key === 'other';
    orgTypeOtherCtrl?.setValidators(isOtherSelected
      ? [Validators.required, Validators.maxLength(15)]
      : [Validators.maxLength(15)]);
    orgTypeOtherCtrl?.updateValueAndValidity();

    const step2Controls = ['companyName', 'website', 'organisationType', 'organisationTypeOther', 'department', 'role', 'phonenumber'];
    const hasInvalid = step2Controls.some(name => this.signupform.get(name)?.invalid);
    if (hasInvalid) {
      step2Controls.forEach(name => this.signupform.get(name)?.markAsTouched());
      this.stepErrorMsg = 'Please complete all identified mandatory fields.';
      return;
    }
    this.stepErrorMsg = '';
    this.currentStep = 3;
  }

  goToPrevious(): void {
    this.stepErrorMsg = '';
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  submitSignup() {
    // Show blocked message if form incomplete or terms not accepted
    if (this.signupform.invalid || !this.check) {
      this.signupform.markAllAsTouched();
      this.registerBlockedMsg = 'All mandatory fields must be completed along with the acceptance of Terms of Use to register.';
      return;
    }
    this.registerBlockedMsg = '';
    // Prevent double-submit
    if (this.register) {
      return;
    }
    this.register = true;
    this.submitted = true;
    //True if all the fields are filled
    if (this.submitted) {
      let userName = this.registerForm.value.fullName;
      let lastName = this.registerForm.value.lastName;
      userName = userName.replace(/\w\S*/g, function (txt: any) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      lastName = lastName.replace(/\w\S*/g, function (txt: any) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      //(this.registerForm.value.displayName, this.signupform.value.companyName, this.registerForm.value, this.signupform.value, this.imgUrl)
      const displayName = this.registerForm.value.displayName;
      const company = this.signupform.value.companyName;
      let organisationType = this.signupform.value.organisationType;
      if (organisationType?.key === 'other') {
        organisationType = { ...organisationType, otherText: this.signupform.value.organisationTypeOther };
      }
      const email = this.registerForm.value.email.trim().toLowerCase();
      const phone = this.signupform.value.phonenumber?.e164Number
        || this.signupform.value.phonenumber
        || '';
      const pswrd = this.signupform.value.password.trim();
      const re_pswrd = this.signupform.value.confirm_password.trim();
      const address1 = this.signupform.value.address1;
      const address2 = this.signupform.value.address2;
      const city = this.signupform.value.city;
      const country = this.signupform.value.country.name;
      isoCountries.registerLocale(require("i18n-iso-countries/langs/en.json"));
      const twoLetterCode = this.signupform.value.country.code;
      const threeLetterCode = isoCountries.alpha2ToAlpha3(twoLetterCode);
      const zip_code = this.signupform.value.zip_code;
      let quotationAmount = 0;
      if (this.quotation) {
        quotationAmount = +this.quotationAmount;
      }
      const role = this.signupform.value.role;
      const website = this.signupform.value.website;
      const department = this.signupform.value.department
      const userplan = Number(this.selectedPlan);

      this.recaptchaV3Service.execute('importantAction').subscribe((token: string) => {
        const reCAPTCHAToken = token;
        let userData = {
          name: userName,
          displayname: displayName,
          company: company,
          phone: phone,
          email: email,
          password: pswrd,
          photoFile: this.userPhotoFile,
          address1: address1,
          address2: address2,
          city: city,
          country: country,
          countryCode: threeLetterCode,
          zip_code: zip_code,
          lastName: lastName,
          organisationType: organisationType,
          reCAPTCHAToken: reCAPTCHAToken,
          quotation: this.quotation,
          quotationAmount: quotationAmount,
          role: role,
          website: website,
          department: department,
          user_plan: userplan
         }

        this.userService.addUser(userData).subscribe((res: any) => {
          if (res.Msg != 'Failed captcha verification') {
            const dialogRef = this.matdialog.open(RegistersuccessComponent, {
              width: '60%', backdropClass: 'blurred', disableClose: true,
              data: { user: '', type: 'registration' }
            });
          }
          if (res.Msg.includes('Successfully registered')) {
            if (email) {
              const mailObj = {
                id: email,
                sub: 'Thank you',
                content: 'Thank you for registering with www.risingsunmart.com'
              }
            }
            this.warnMsg = res.Msg;
            this.successMsg = true;
            this.authService.deleteCookie('plan');
          }
        });
      });

    }

  }
  acceptTerms() {
    this.check = !this.check
  }
  clearImages() {
    this.imgUrl = '';
  }
  onFileSelected(event: any) {
    // this.userPhotoFile = this.sanitize.bypassSecurityTrustResourceUrl( event.target.files[0]);
    const allowedExtensions = /(\.jpg|\.jpeg)$/i;
    this.userPhotoFile = event.target.files[0];
    let docs = document.getElementById('term')
    if (docs) {
      docs.click();
    }
    if (!allowedExtensions.exec(this.userPhotoFile.name)) {
      this.imageType = true;
      this.imgUrl = '';
    } else {
      this.imageType = false;
      if (this.userPhotoFile.size < 20480) {
        /* less than 20kb */
        this.oversize = false;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.imgUrl = e.target.result;
          this.uploaded = true
          this.upload = true
        };
        reader.readAsDataURL(this.userPhotoFile);
      } else {
        this.oversize = true;
        this.imgUrl = '';
      }
    }
  }
  OpenPopup(event?) {

    event?.preventDefault();
    const dialogRef = this.matdialog.open(AgreeComponent, {
          width: '65%',
          maxHeight: '90vh',
          backdropClass: 'blurred',
          disableClose: true,
      data: {type: 'terms'}
     });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.click === 1) {
        this.check = true;
      }
      else {
      this.check = false;
      }
    });
    backdropClass: 'backdropBackground' // This is the "wanted" line
  }

  requestQuotation() {
    this.quotationAmount = 0;
    let userEmail = this.registerForm.value.email.trim().toLowerCase();

      const dialogRef = this.matdialog.open(QuotationPopupComponent,
      {
        data: { user: userEmail,message: 'register'},
        backdropClass: 'blurred',
        disableClose: true,
        width: '60%',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.type === 1) {
          this.quotation = true;
          this.quotationAmount = result.quotationAmount;
        }
        else
          this.quotation = false;
      });
  }

  acceptSubscription(option) {
    this.selectedOption = option;
    if (this.selectedOption === 'withDeposit') this.subscription = false;
    else if (this.selectedOption === 'withoutDeposit') this.subscription = true;

    if (this.subscription) this.quotation = false;
    else if (!this.subscription && this.quotationAmount > 0) this.quotation = true;
  }

  private emailNotTakenValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const trimmed = (control.value ?? '').trim().toLowerCase();
      if (!trimmed) return of(null);
      return timer(600).pipe(
        switchMap(() => this.userService.chkRegisteredUser({ userEmail: encodeURIComponent(trimmed) })),
        map((result: any) => result?.Msg === 'Wrong password' ? { emailTaken: true } : null),
        catchError(() => of(null))
      );
    };
  }

  compareOrgType(a: any, b: any): boolean {
    return a && b ? a.key === b.key : a === b;
  }

  onCountryPanelClose(): void {
    // Reset search filter so full list is shown next time the dropdown opens
    this.countryFilterCtrl.setValue('', { emitEvent: false });
    this.filteredCountries = [...this.countries];
  }

  compareCountry(a: any, b: any): boolean {
    return a && b ? a.code === b.code : a === b;
  }

  onOrgTypeChange(event: any): void {
    const otherCtrl = this.signupform.get('organisationTypeOther');
    if (event?.value?.key === 'other') {
      otherCtrl?.setValidators([Validators.required, Validators.maxLength(15)]);
    } else {
      otherCtrl?.setValidators([Validators.maxLength(15)]);
      otherCtrl?.setValue('');
    }
    otherCtrl?.updateValueAndValidity();
  }

  getOrgTypeTooltip(name: string): string {
    const tooltips: Record<string, string> = {
      'Satellite Operator': 'Choose this if you are a satellite operator wanting to be a user on the platform.',
      'Application Provider': 'Choose this if you are a service provider. If an end user, choose Commercial/Enterprise. If both, choose Other.',
      'Other': 'The type entered will be used in the KYC verification process.',
    };
    return tooltips[name] || '';
  }

  planClick(value:number){
    this.authService.setCookie('plan', value.toString(), 30);
     this.selectedPlan = value.toString()
     this.authService.emitPlan(value.toString());
    this.notRegistered = false;
    this.currentStep = 1;
    this.stepErrorMsg = '';
  }
  onResetClick(event: Event){
    event.preventDefault();
    this.draftExistsMsg = '';
    this.draftSavedState = 'idle';
    this.draftRestoreMsg = '';
    this.authService.deleteCookie('plan');
     this.selectedPlan = null;
     this.notRegistered = null;
     this.authService.emitPlan(null);
     this.registerForm = this.formBuilder.group({
      fullName: ['',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
          this.vs.userNameValidator,
        ],
      ],
      lastName: ['',
      [
        Validators.required,
        Validators.maxLength(50),
        this.vs.userNameValidator,
      ],
     ],
      displayName: ['',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(15),
          this.vs.userNameValidator,
        ],
      ],
      email: ['', [Validators.required, this.vs.trimmedEmailPatternValidator()], [this.emailNotTakenValidator()]],
    });
    this.signupform = this.formBuilder.group({
      companyName: [
        '',
        [
          Validators.required
        ],
      ],
      organisationType: [
        '',
        [
          Validators.required
        ],
      ],
      organisationTypeOther: ['', [Validators.maxLength(15)]],
      phonenumber: ['', [Validators.required]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern('^(?=.*[A-Z])(?=.*[!@#$%^&_+=]).*$'),
      ]],
      confirm_password: ['', [Validators.required]],
      address1: ['', [Validators.required]],
      address2: [''],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      zip_code: ['', [Validators.required]],
      role: [
        '',
        [
          Validators.required
        ],
      ],
      department: [
        '',
        [
          Validators.required
        ],
      ],
      website: ['', [
        Validators.required,
        Validators.pattern(
          /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/ // URL regex
        )],
      ],
    }, {
      validator: ConfirmedValidator('password', 'confirm_password')
    });
     this.register = false;
    this.submitted = false;
    this.quotation = false;
    this.check = false;
    this.uploaded = false;
    this.oversize = false;
    this.imageType = false;
    this.userPhotoFile;
    this.imgUrl = '';
    this.countryFilterCtrl.setValue('');
    this.filteredCountries = [...this.countries];
    this.currentStep = 1;
    this.stepErrorMsg = '';
    this.subscribeStepValidation();
  }

  private subscribeStepValidation(): void {
    const step2Controls = ['companyName', 'website', 'organisationType', 'organisationTypeOther', 'department', 'role', 'phonenumber'];
    this.registerForm.statusChanges.subscribe(() => {
      if (this.currentStep === 1) {
        if (this.stepErrorMsg && this.registerForm.valid) {
          this.stepErrorMsg = '';
        }
        // Show emailTaken error immediately (without waiting for blur)
        const emailCtrl = this.registerForm.get('email');
        if (emailCtrl?.hasError('emailTaken') && !emailCtrl.touched) {
          emailCtrl.markAsTouched();
        }
      }
    });
    this.signupform.statusChanges.subscribe(() => {
      if (this.stepErrorMsg && this.currentStep === 2) {
        const allValid = step2Controls.every(n => this.signupform.get(n)?.valid);
        if (allValid) this.stepErrorMsg = '';
      }
      if (this.registerBlockedMsg && this.currentStep === 3 && this.signupform.valid) {
        this.registerBlockedMsg = '';
      }
    });
  }

  togglePricingAccordion(planId: number) {
    this.expandedPricingPlanIds = this.isPricingAccordionOpen(planId)
      ? this.expandedPricingPlanIds.filter((id) => id !== planId)
      : [...this.expandedPricingPlanIds, planId];
  }

  isPricingAccordionOpen(planId: number): boolean {
    return this.expandedPricingPlanIds.includes(planId);
  }

  openTooltip(template: TemplateRef<any>,plan) {
  const selectedPlan = this.plans.find(p => p.planId === plan);

  const accessDetails = selectedPlan?.accessDetails || [];
   console.log("accessDetails",accessDetails)
    this.dialogRef.open(template, {
    panelClass: 'black-dialog-bg',
    data: {
      accessDetails: accessDetails,
      product: 'planUpgrade'
    }
  });
}
}
